import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFastForward: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fast-forward"><path d="M12.3742 11.3303L4.75 5.5V18.5L12.3742 12.6697M12.75 5.5L21.25 12L12.75 18.5V5.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFastForward;
